import { useEffect } from "react";
import { usePermissions } from "./usePermissions";

export const useDisableByPermission = (
  controller: string,
  setIsDisabled: React.Dispatch<React.SetStateAction<boolean>>,
  method: string = "Modify"
) => {
  const { hasAccessByController } = usePermissions(controller);

  useEffect(() => {
    !hasAccessByController(method) && setIsDisabled(true);
  }, [hasAccessByController, setIsDisabled, method]);
};
